export default __webpack_public_path__ + "static/SamsungOne-700-36c53008df95a1f910ca798066cb5466.ttf";